import { Storage } from '@ssml-editor/modules';

class EditorStorageService {
  constructor(databaseName, storeName) {
    if (databaseName) {
      const name = `${EditorStorageService.DATABASE_NAME_PREFIX}_${databaseName}`;
      this._storager = new Storage({
        name,
        storeName: storeName || EditorStorageService.STORE_NAME
      });
    }
  }
  _storager = void 0;
  async read(key) {
    return await this._storager?.getItem(key) || void 0;
  }
  async save(key, data) {
    if (this._storager) {
      const result = await this._storager?.setItem(key, data);
      if (result === data) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
  async remove(key) {
    return await this._storager?.removeItem(key);
  }
  static DATABASE_NAME_PREFIX = "ssml_editor";
  static STORE_NAME = "editor";
}

export { EditorStorageService };
//# sourceMappingURL=editor-storage-service.js.map
